module.exports = __webpack_public_path__ + "img/view2.1f3f30e6.jpg";